// dev config
let dev = {
    version: '1.5.6',
    env: 'dev',
    api: {
        // host: 'http://192.168.1.84:5100',  // java dev // 魏文斌
        host: 'https://wbtest.lingzhuyun.com/java', // java sit 外网
        pythonHost: 'https://wbtest.lingzhuyun.com/api', // sit 外网
        // pythonHost: 'http://192.168.1.230:7000/api', // python dev
        secret: '',
        key: ''
    }
}

window.ver = dev.version
export default dev



// WEBPACK FOOTER //
// ./src/env/dev.js